import { Box, Button, Stack, Typography } from '@mui/material';

interface DropboxAuthRequiredProps {
  onConnect: () => Promise<void>;
  onCancel: () => void;
}

const DropboxAuthRequired = ({ onConnect, onCancel }: DropboxAuthRequiredProps) => (
  <Box sx={{ mt: 0.5, p: 1.5, border: '1px solid', borderColor: 'divider', borderRadius: 1 }}>
    <Typography variant="body2" color="text.secondary" sx={{ mb: 1 }}>
      Dropbox authentication required to manage folders.
    </Typography>
    <Stack direction="row" spacing={1}>
      <Button size="small" variant="contained" onClick={onConnect}>
        Connect Dropbox
      </Button>
      <Button size="small" variant="text" onClick={onCancel}>
        Cancel
      </Button>
    </Stack>
  </Box>
);

export default DropboxAuthRequired;
